import { Component, Inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Temporal } from '@js-temporal/polyfill';
import { AppStartupService } from '@ridango/core';

export interface FormatOption {
    date: string;
    value: number;
    label: string;
}

@Component({
    selector: 'rwidget-select-period-lend-modal',
    templateUrl: './select-period-lend-modal.component.html',
    styleUrls: ['./select-period-lend-modal.component.scss']
})
export class SelectPeriodLendModalComponent implements OnInit {
    @Input() selected: FormatOption;
    @Input() expirationDate: string;
    public defaultOptions: number[] = [4, 8, 24, 48];
    public formatOptions: FormatOption[] = [];
    public assetsPath$ = this.applicationFacade.assetsPath$;
    public selectedForm = new FormControl();
    private timeZone = this.appStartup.getTimezone();

    constructor(
        @Inject('ENV') public env: Env,
        private modalCtrl: ModalController,
        private translate: TranslateService,
        private applicationFacade: ApplicationFacade,
        private appStartup: AppStartupService
    ) {}

    ngOnInit() {
        this.handleFormatOptions();
    }

    public cancel() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    public confirm() {
        const matchedOption = this.formatOptions.find((option) => option.value === this.selectedForm.value);
        return this.modalCtrl.dismiss(matchedOption, 'confirm');
    }

    public handleFormatOptions() {
        const expirationZonedDateTimeUtc = Temporal.Instant.from(this.expirationDate).toZonedDateTimeISO('UTC');
        const expirationDateWithCorrectTimeZone = expirationZonedDateTimeUtc.withTimeZone(this.timeZone);

        this.formatOptions = this.defaultOptions
            .map((hour, index) => {
                const validUntilFormatted = Temporal.Now.instant().toZonedDateTimeISO(this.timeZone);
                let date = validUntilFormatted.add({ hours: hour });

                if (index === 0) {
                    date = date.add({ minutes: 5 });
                }

                return {
                    value: hour,
                    date: this.formatTemporalDate(date),
                    label: `${hour} ${this.translate.instant('HOURS')}`
                };
            })
            .filter((option) => {
                const optionDate = Temporal.PlainDateTime.from(option.date);
                const expiredDate = Temporal.PlainDateTime.from(expirationDateWithCorrectTimeZone);
                return Temporal.PlainDateTime.compare(optionDate, expiredDate) < 0;
            });

        this.formatOptions.push({
            value: 999,
            date: this.formatTemporalDate(expirationDateWithCorrectTimeZone),
            label: this.translate.instant('UNTIL_EXPIRES')
        });

        if (this.selected) {
            this.selectedForm.setValue(this.selected.value);
        }
    }

    private formatTemporalDate(temporalDate): string {
        return `${temporalDate.year}-${String(temporalDate.month).padStart(2, '0')}-${String(temporalDate.day).padStart(2, '0')} ${String(temporalDate.hour).padStart(2, '0')}:${String(temporalDate.minute).padStart(2, '0')}`;
    }
}
